import { render, staticRenderFns } from "./DateBoxField.vue?vue&type=template&id=2d8426bf&scoped=true"
import script from "./DateBoxField.vue?vue&type=script&lang=js"
export * from "./DateBoxField.vue?vue&type=script&lang=js"
import style0 from "./DateBoxField.vue?vue&type=style&index=0&id=2d8426bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8426bf",
  null
  
)

export default component.exports